import { render, staticRenderFns } from "./selfphoto-notice.vue?vue&type=template&id=0db32ddf&"
var script = {}
import style0 from "./selfphoto-notice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports